import React from "react";
import { Routes, Route, useParams, Navigate } from "react-router-dom";
import { default as Links } from "./links";
import { default as Home } from "./home";
import { default as Apply } from "./apply";
import { default as ApplyIntegrator } from "./apply/daikin";
import { default as ApplySunburn } from "./apply/sunburn";
import { default as ApplySunRun } from "./apply/sunrun";
import { default as ApplyGoodLeapPlus } from "./apply/goodleapplus";
// import { default as GoodLeapPlusHome } from "./goodleapplus";
import { default as Calculator } from "./application/calculator";
import { default as ApplyBundleLoan } from "./apply/bundle";
import { default as Partners } from "./partners";
import { default as Edit } from "./edit";
import { default as Requests } from "./requests";
import { default as Request } from "./request";
import { default as PublicRequest } from "./request-public";
import { default as FixSubmittingUser } from "./fix-submitting-user";
import { default as ComingSoon } from "./coming-soon";
import { default as Organizations } from "./organizations";
import { default as Export } from "./export";
import { default as Keys } from "./keys"
import { default as AdminErrorLogs } from "./admin-error-logs";
import { default as AdminErrorEmailSettings } from "./admin-error-email-settings";
import { default as NotFoundPage } from "../utils/not-found";
import {
  isFinancingPlusDomain,
  isGoodLeapPlusMarketingDomain,
  isPayDomain,
} from "../utils/is-goodleapplus-domain";
import { default as FinancingPlusHome } from "./financingplus";
import { default as PayLinkHome } from "./paylink";
import { default as Pay } from "./pay";
import { default as GeneratePaymentLink } from "./pay/generate";

const ApplyIntegratorRoute = () => {
  const { integrator } = useParams();

  // Check if the 'integrator' starts with 'dk-'
  if (integrator.startsWith('dk-')) {
    return <ApplyIntegrator />;
  }

  // Fallback: redirect to Apply component if it doesn't match the pattern
  return <Navigate to={`/apply/${integrator}`} />;
};

const Router = () => {
  const payHost = isPayDomain();
  const financingPlusHost = isFinancingPlusDomain();
  const goodLeapPlusHost = isGoodLeapPlusMarketingDomain();

  return (
    <>
      <Routes>
      {payHost ? (
        <>
          {/* pay.goodleap.plus|link|dev — marketing home at /; signed-link helper; payment flow at /:id */}
          <Route path="/" element={<PayLinkHome />} />
          <Route path="/generate" element={<GeneratePaymentLink />} />
          <Route path="/generate/:id" element={<GeneratePaymentLink />} />
          <Route path="/:id" element={<Pay />} />
          <Route path="*" element={<NotFoundPage />} />
        </>
      ) : financingPlusHost ? (
        <>
          {/* Toolkit marketing home; same apply flow as goodleap.plus/:id */}
          <Route path="/" element={<FinancingPlusHome />} />
          <Route path="/:id" element={<ApplyGoodLeapPlus />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </>
      ) : goodLeapPlusHost ? (
        <>
          <Route path="/" element={<FinancingPlusHome />} />
          <Route path="/:id" element={<ApplyGoodLeapPlus />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </>
      ) : (
      <>
        <Route path="/" exact element={<Home />} />
        <Route path="/financingplus" exact element={<FinancingPlusHome />} />
        <Route path="/paylink" exact element={<PayLinkHome />} />
        <Route path="/pay/generate" exact element={<GeneratePaymentLink />} />
        <Route path="/pay/generate/:id" exact element={<GeneratePaymentLink />} />
        <Route path="/goodleapplus" exact element={<FinancingPlusHome />} />
        {/* Before /:client/:id so /goodleapplus/<uuid> is not captured as client=goodleapplus */}
        <Route path="/goodleapplus/:id" exact element={<ApplyGoodLeapPlus />} />
        {/* Pay — before /:client/:id so /{uuid}/payments is not treated as client/id */}
        <Route path="/:id/payments" exact element={<Pay />} />
        <Route path="/pay/:id" exact element={<Pay />} />
        {/* Static /sunrun before /:client/:id so SunRun never hits generic Apply */}
        <Route path="/sunrun/:id" exact element={<ApplySunRun />} />
        <Route path="/sunrun/calculator/:id" exact element={<Calculator />} />
        <Route path="/:client/:id" exact element={<Apply />} />
        <Route path="/dk-:integrator/:client/:id" exact element={<ApplyIntegrator />} />
        <Route path="/:client/:id/:offerId" exact element={<Apply />} />
        <Route path="/apply/:client/:id" exact element={<ApplySunburn />} />
        <Route path="/:integrator/:client/la/:id" exact element={<Apply />} />
        <Route path="/:integrator/:client/:id" exact element={<ApplyIntegratorRoute />} />
        <Route path="/glp/:client/:bundleClientId/:id" exact element={<ApplyBundleLoan />} />
        <Route path="/edit/:id" element={<Edit />} />
        <Route path="/edit/:action/:id" exact element={<Edit />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/admin" element={<Partners />} />
        <Route path="/links" element={<Links />} />
        <Route path="/admin-errors" element={<AdminErrorLogs />} />
        <Route path="/admin-error-email-settings" element={<AdminErrorEmailSettings />} />
        <Route path="/requests" element={<Requests />} />
        <Route path="/request/:id" element={<Request />} />
        <Route path="/request-quicklink/:id" exact element={<PublicRequest />} />
        <Route path="/fix-submitting-user/:requestId" exact element={<FixSubmittingUser />} />
        <Route path="/coming-soon" exact element={<ComingSoon />} />
        <Route path="/organizations/:id" element={<Organizations />} />
        <Route path="/export" element={<Export />} />
        <Route path="/keys" element={<Keys />}/>
        <Route path="/coming-soon" element={<ComingSoon />}/>
        <Route path="*" element={<NotFoundPage />} />
        </>
      )}
      </Routes>
    </>
  );
};

export default Router;
